<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <!--    Editor Modal  -->
    <b-modal
        id="modal-Editor"
        centered
        ok-only
        ok-title="ثبت"
        title="افزودن کد html"
        @ok.preventDefault()="customButtonClick"
    >
      <b-row>
        <span class="mx-1 mb-1">کد HTML خود را در اینجا قرار دهید</span>
        <b-col cols="12">
          <textarea v-model="rawHTML" class="form-control"></textarea>
        </b-col>
      </b-row>
    </b-modal>

   <div>
    <b-row>
      <b-col cols="12">
        <b-card>

          <h4>اطلاعات کلی</h4>

      <!-- Media -->
      <b-media class="my-2">
        <template >
          <b-avatar
              ref="previewEl"
              :src="base64ImageSrc"
              size="300px"
              rounded
          />
        </template>
        <div class="d-flex flex-wrap mt-1">
          <b-button
              variant="primary"
              @click="$refs.refInputEl.click()"
          >
            <input
                ref="refInputEl"
                type="file"
                class="d-none"
                @input="makeBase64Pic"
            >
            <span class="d-none d-sm-inline">+ عکس</span>
            <feather-icon
                icon="EditIcon"
                class="d-inline d-sm-none"
            />
          </b-button>
          <b-button
              variant="outline-secondary"
              class="ml-1"
              @click="deleteProductPic()"
          >
            <span class="d-none d-sm-inline">حذف</span>
            <feather-icon
                icon="TrashIcon"
                class="d-inline d-sm-none"
            />
          </b-button>
        </div>
      </b-media>

      <div>

        <b-form>
          <b-row>

            <!-- Field:  Title -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label="عنوان"
                  label-for="Title"
              >
                <b-form-input
                    id="Title"
                    v-model="defaultData.title"
                />
              </b-form-group>
            </b-col>

            <!-- Field: isFree -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label="وضعیت"
                  label-for="user-status"
              >
                <v-select
                    v-model="defaultData.isFree"
                    :options="isFreeOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="user-status"
                />
              </b-form-group>
            </b-col>

            <!-- Field:  price -->
            <b-col
                v-if="!defaultData.isFree"
                cols="12"
                md="4"
            >
              <b-form-group
                  label="قیمت (تومان)"
                  label-for="price"
              >
                <b-form-input
                    id="price"
                    v-model="defaultData.price"
                    :aria-disabled="!defaultData.isFree"
                />
              </b-form-group>
            </b-col>

            <!-- Field: isAvailable -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label="موجودیت"
                  label-for="isAvailable"
              >
                <v-select
                    v-model="defaultData.available"
                    :options="isAvailableOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="isAvailable"
                />
              </b-form-group>
            </b-col>

            <!-- Field:  beforeDiscount -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label="قیمت قبلی (خط خورده)"
                  label-for="beforeDiscount"
              >
                <b-form-input
                    id="beforeDiscount"
                    v-model="defaultData.beforeDiscount"
                />
              </b-form-group>
            </b-col>

            <!-- Field:  subtitle -->
            <b-col
                cols="12"
            >
              <b-form-group
                  label="سوتیتر"
                  label-for="subtitle"
              >
                <b-form-input
                    id="subtitle"
                    v-model="defaultData.subtitle"
                />
              </b-form-group>
            </b-col>

            <!--   Field: seoDescription     -->
            <b-col
                cols="12"
            >
              <b-form-group
                  label="توضیحات (سئو)"
                  label-for="seoDescription"
              >
                <b-form-textarea
                    id="seoDescription"
                    v-model="defaultData.seoDescription"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <!-- Field:  description -->
            <b-col cols="12">
              <b-form-group
                  class="mb-2"
                  label="توضیحات"
                  label-for="product-content"
              >
                <ckEditorMain ref="editorContent" @getEditorContent="setEditorContent" :defaultContent="defaultData.description"></ckEditorMain>
              </b-form-group>
            </b-col>

            <!-- Field: type -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label="انتخاب نوع محصول"
                  label-for="type"
              >
                <v-select
                    v-model="defaultData.type"
                    :options="types"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="productCategoryId"
                />
              </b-form-group>
            </b-col>

            <!-- Field: productCategoryId -->
            <b-col v-if="productCategories !== null && defaultData.type !== 0 && defaultData.type !== 1 && defaultData.type !== 10"
                   cols="12"
                   md="4"
            >
              <b-form-group
                  label="دسته بندی"
                  label-for="productCategoryId"
              >
                <v-select
                    v-model="defaultData.productCategoryId"
                    :options="productCategories"
                    label="name"
                    :reduce="name => name.productCategoryId"
                    :clearable="false"
                    input-id="productCategoryId"
                />
              </b-form-group>
            </b-col>

            <!-- Field: productCategoryId -->
            <b-col v-if="courseCategories !== null && defaultData.type !== 0 && defaultData.type === 1 "
                   cols="12"
                   md="4"
            >
              <b-form-group
                  label="دسته بندی"
                  label-for="productCategoryId"
              >
                <v-select
                    v-model="defaultData.productCategoryId"
                    :options="courseCategories"
                    label="name"
                    :reduce="name => name.productCategoryId"
                    :clearable="false"
                    input-id="productCategoryId"
                />
              </b-form-group>
            </b-col>

            <!-- Field: courseId -->
            <b-col
                v-if="defaultData.type === 1"
                cols="12"
                md="4"
            >
              <b-form-group
                  label="انتخاب دوره"
                  label-for="type"
              >
                <v-select
                    v-model="defaultData.courseId"
                    :options="courses"
                    label="name"
                    :reduce="name => name.courseId"
                    :clearable="false"
                    input-id="productCategoryId"
                />
              </b-form-group>
            </b-col>

            <b-col
                v-if="defaultData.type === 8"
                cols="12"
                md="4"
            >
              <b-form-group
                  label="انتخاب تست"
                  label-for="psychologicalTestId"
              >
                <v-select
                    v-model="defaultData.psychologicalTestId"
                    :options="productTests"
                    label="title"
                    :reduce="title => title.id"
                    :clearable="false"
                    input-id="psychologicalTestId"
                />
              </b-form-group>
            </b-col>

<!--            <b-col-->
<!--                cols="12"-->
<!--                md="4"-->
<!--            >-->
<!--              <b-form-group-->
<!--                  label="نوع خدمات مالیاتی"-->
<!--                  label-for="taxServiceType"-->
<!--              >-->
<!--                <v-select-->
<!--                    v-model="defaultData.taxServiceType"-->
<!--                    :options="taxTypes"-->
<!--                    label="label"-->
<!--                    :reduce="label => label.value"-->
<!--                    :clearable="true"-->
<!--                    input-id="taxServiceType"-->
<!--                />-->
<!--              </b-form-group>-->
<!--            </b-col>-->

          </b-row>
        </b-form>

        <b-button
            :disabled="defaultData.type < 1"
            variant="primary"
            class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="createProduct"
        >
          ثبت
        </b-button>

      </div>
    </b-card>

<!--    <b-card>-->

<!--      <h4 class="">تریلر</h4>-->

<!--      <b-row>-->
<!--        &lt;!&ndash; Field: trailerFile &ndash;&gt;-->
<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--        >-->

<!--          <b-button-->
<!--              class="mt-2 col-12"-->
<!--              variant="warning"-->
<!--              @click="$refs.refInputEl2.click()"-->
<!--          >-->
<!--            <input-->
<!--                ref="refInputEl2"-->
<!--                type="file"-->
<!--                class="d-none"-->
<!--                @change="makeBase64"-->
<!--            >-->
<!--            <span class="">بارگذاری</span>-->
<!--          </b-button>-->

<!--        </b-col>-->

<!--        <b-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--            class="pt-2"-->
<!--        >-->
<!--            <span class="text-danger">فایل مورد نظر باید کمتر از 25 مگابایت باشد.</span>-->
<!--        </b-col>-->
<!--      </b-row>-->

<!--    </b-card>-->

        <!--  Category Properties  -->
<!--        <b-card ref="categoryProperties" v-if="defaultData.productCategoryId !== null">-->

<!--          <h4 class="text-primary">خصوصیات پیشفرض</h4>-->

<!--          <hr class="my-2">-->

<!--         <b-row>-->
<!--           <b-col-->
<!--               v-for="i in defaultData.properties"-->
<!--               v-if="i.categoryPropertyId > 0"-->
<!--               cols="8"-->
<!--           >-->
<!--             <b-form-group-->
<!--                 label-cols="4"-->
<!--                 label-size="lg"-->
<!--                 :label="i.name"-->
<!--                 :label-for="i.name"-->
<!--             >-->
<!--               <b-form-input-->
<!--                   :id="i.name"-->
<!--                   v-model="i.value"-->
<!--               />-->
<!--             </b-form-group>-->
<!--           </b-col>-->

<!--         </b-row>-->

<!--          <b-row>-->

<!--            <b-col cols="12">-->
<!--              <h4 class="text-primary">خصوصیات اضافی</h4>-->

<!--              <hr class="my-2">-->
<!--            </b-col>-->

<!--            <NewCategoryProperty-->
<!--                v-for="i in defaultData.properties"-->
<!--                :key="i.id"-->
<!--                :propertyData="i"-->
<!--            />-->

<!--&lt;!&ndash;            <b-col&ndash;&gt;-->
<!--&lt;!&ndash;                v-for="(i,index) in defaultData.properties"&ndash;&gt;-->
<!--&lt;!&ndash;                v-if="i.name === ''"&ndash;&gt;-->
<!--&lt;!&ndash;                cols="12"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <b-row>&ndash;&gt;-->

<!--&lt;!&ndash;                <b-form-group&ndash;&gt;-->
<!--&lt;!&ndash;                    class="col-3"&ndash;&gt;-->
<!--&lt;!&ndash;                    label="name"&ndash;&gt;-->
<!--&lt;!&ndash;                    label-for=""&ndash;&gt;-->
<!--&lt;!&ndash;                >&ndash;&gt;-->
<!--&lt;!&ndash;                  <b-form-input&ndash;&gt;-->

<!--&lt;!&ndash;                      v-model="i.name"&ndash;&gt;-->
<!--&lt;!&ndash;                  />&ndash;&gt;-->
<!--&lt;!&ndash;                </b-form-group>&ndash;&gt;-->

<!--&lt;!&ndash;                <b-form-group&ndash;&gt;-->
<!--&lt;!&ndash;                    class="col-5"&ndash;&gt;-->
<!--&lt;!&ndash;                    label="value"&ndash;&gt;-->
<!--&lt;!&ndash;                    label-for=""&ndash;&gt;-->
<!--&lt;!&ndash;                >&ndash;&gt;-->
<!--&lt;!&ndash;                  <b-form-input&ndash;&gt;-->

<!--&lt;!&ndash;                      v-model="i.value"&ndash;&gt;-->
<!--&lt;!&ndash;                  />&ndash;&gt;-->
<!--&lt;!&ndash;                </b-form-group>&ndash;&gt;-->

<!--&lt;!&ndash;              </b-row>&ndash;&gt;-->
<!--&lt;!&ndash;            </b-col>&ndash;&gt;-->
<!--          </b-row>-->

<!--          <b-button-->
<!--              variant="primary"-->
<!--              @click="defaultData.properties.push({'name':'','value':'','categoryPropertyId':0})"-->
<!--          >-->
<!--            <span class="text-nowrap">+ افزودن خصوصیت</span>-->
<!--          </b-button>-->

<!--        </b-card>-->
      </b-col>
    </b-row>
  </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BAvatar,
  BOverlay,
  BModal
} from 'bootstrap-vue'
import vSelect from "vue-select";
import {ProductCategoryGetAllRequest, ProductGetAllRequest} from "@/libs/Api/Product";
import {ProductCategoryPropertyGetByCategoryIdRequest} from "@/libs/Api/Product";
import {ProductCreateRequest} from "@/libs/Api/Product";
import {ProductCourseGetAllRequest} from "@/libs/Api/Product";
import NewCategoryProperty from "@/views/apps/e-commerce/e-commerce-add/NewCategoryProperty";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {ProductCategoryGetAllProductCategoriesRequest} from "@/libs/Api/Product";
import {ProductCategoryGetAllCourseCategoriesRequest} from "@/libs/Api/Product";

// Quill
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import {quillEditor} from "vue-quill-editor";
import ckEditorMain from "@/views/components/ckEditorMain";
import {PsychologicalTestGetLightListRequest} from "@/libs/Api/Test";
import {nice} from "echarts/lib/util/number";


export default {
  title:"افزودن محصول - پنل ادمین نهایی شو",
  name: "ECommerceAdd",
  components:{
    NewCategoryProperty,
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    BModal,
    vSelect,
    ckEditorMain
  },
  data(){
    return{
      overlay:false,
      propertiesData:[],
      defaultData:{
        isDeleted: false,
        productId: null,
        parentId:null,
        title: "",
        description: "",
        productCategoryId: null,
        courseScheduleId: null,
        courseId: null,
        price: "",
        isFree: true,
        seoDescription:'',
        type: 0,
        imageFile: "",
        fileData: null,
        subtitle: '',
        beforeDiscount:'',
        trailerFile:'',
        viewCounts: 0,
        properties: [],
        available:false,
        psychologicalTestId:null,
        taxServiceType:null,
        productInfos: [
          {
            title: "",
            icon: ""
          },
          {
            title: "",
            icon: ""
          },
          {
            title: "",
            icon: ""
          },
        ]
      },
      showHTML: false,
      snowOption: {
        theme: 'snow',
        modules: {
          toolbar: '#toolbar'
        },
      },
      rawHTML: '',
      isFreeOptions:[
        {label : 'رایگان' , value : true},
        {label : 'پولی' , value : false}
      ],
      types:[
        {label : 'دوره' , value : 1},
        // {label : 'فایل' , value : 3},
        // {label : 'پادکست' , value : 4},
        // {label : 'پکیج', value: 7},
        // {label : 'تست روانشناسی', value: 8},
      ],
      taxTypes:[
        {label : 'تولید محتوای آموزشی تصویری در زمینه مهارت‌های ارتباطی' , value : 1},
        {label : 'تولید محتوای آموزشی تصویری در زمینه رشد فردی' , value : 2},
        {label : 'تولید محتوای آموزشی تصویری در زمینه تحکیم خانواده' , value : 3},
      ],
      isAvailableOptions:[
        {label : 'موجود' , value : true},
        {label : 'ناموجود' , value : false}
      ],
      base64ImageSrc:null,
      productCategories:null,
      courseCategories:null,
      categoryProperties:null,
      courses:null,
      productCourses:null,
      productTests:[],
    }
  },
  computed:{
    defaultDataProductCategoryId(){
      return this.defaultData.productCategoryId;
    },
    defaultDataProductType(){
      return this.defaultData.type;
    },
    defaultDataImageFile(){
      return this.defaultData.imageFile
    }
  },
  watch:{
    defaultDataProductCategoryId(nv,ov){
      this.getCategoryProperties(nv)
    },
    defaultDataProductType(nv,ov){

    },
  },
  async created(){
    await this.getAllProductCategories();
    await this.getAllCourseCategories();
    await this.getAllCourses();
    await this.getProductCourses();
    await this.getProductTests();
  },
  methods:{
    async createProduct(){
      let  _this = this;

      if (_this.defaultData.type !== 8) _this.defaultData.productInfos = null;

      _this.overlay = true;

      let productCreateRequest = new ProductCreateRequest(_this);
      productCreateRequest.setParams(_this.defaultData);
      await productCreateRequest.fetch(function (content){
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.$router.push({name:'apps-e-commerce-shop'})
      }, function (error){
        _this.overlay = false;
        console.log(error)
      })
    },
    async getAllProductCategories(){
      let  _this = this;
      _this.overlay = true;
      let  defaultGetData={
        pageNumber:0,
        count:0,
      }

      let productCategoryGetAllProductCategoriesRequest = new ProductCategoryGetAllProductCategoriesRequest(_this);
      productCategoryGetAllProductCategoriesRequest.setParams(defaultGetData);
      await  productCategoryGetAllProductCategoriesRequest.fetch(function (content){
        _this.productCategories = content.productCategories;
        _this.overlay = true;
      },function (error){
        console.log(error)
        _this.overlay = true;
      })
    },
    async getAllCourseCategories(){
      let  _this = this;
      _this.overlay = true;
      let  defaultGetData={
        pageNumber:0,
        count:0,
      }

      let productCategoryGetAllProductCategoriesRequest = new ProductCategoryGetAllCourseCategoriesRequest(_this);
      productCategoryGetAllProductCategoriesRequest.setParams(defaultGetData);
      await  productCategoryGetAllProductCategoriesRequest.fetch(function (content){
        _this.courseCategories = content.productCategories;
        _this.overlay = true;
      },function (error){
        console.log(error)
        _this.overlay = true;
      })
    },
    async getProductTests(){
      let _this = this;
      _this.overlay = true;

      let psychologicalTestGetLightListRequest = new PsychologicalTestGetLightListRequest(_this);
      await psychologicalTestGetLightListRequest.fetch(function (content){
        _this.overlay = false;
        _this.productTests = content;
      },function (error){
        _this.overlay = false;
        console.log(error)
      })
    },
    async getCategoryProperties(param){
      let _this = this;
      _this.overlay = true;

      let productCategoryPropertyGetByCategoryIdRequest = new ProductCategoryPropertyGetByCategoryIdRequest(_this);
      productCategoryPropertyGetByCategoryIdRequest.setId(param);
      await productCategoryPropertyGetByCategoryIdRequest.fetch(function (content){
        _this.categoryProperties = content
        _this.defaultData.properties = [];
        _this.categoryProperties.forEach(element => _this.defaultData.properties.push({'name':element.name,'val':'','categoryPropertyId':element.categoryPropertyId}))
        // _this.$refs.categoryProperties.scrollIntoView({ behavior: "smooth" });
        _this.overlay = false;
      },function (error){
        console.log(error)
        _this.overlay = false;
      })
    },
    async readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onerror = reject;
        fr.onload = () => {
          resolve(fr.result.split(",")[1]);
        }
        fr.readAsDataURL(file);
      });
    },
    async getAllCourses(){
      let _this = this;
      _this.overlay = true;
      let courseData = {
        pageNumber:0,
        searchCommand : '',
        count: 0
      }

      let productCourseGetAllRequest = new ProductCourseGetAllRequest(_this);
      productCourseGetAllRequest.setParams(courseData);
      await productCourseGetAllRequest.fetch(function (content){
        _this.courses = content.courses;
        _this.overlay = false;
      },function (error){
        _this.overlay = false;
      })
    },
    async getProductCourses(){
      let _this = this;
      _this.overlay = true;
      let getProductData={
        categoryId:0,
        searchByTitle:'',
        pageNumber:0,
        count:0,
        type:1,
        isFree:''
      }

      let productGetAllRequest = new ProductGetAllRequest(_this);
      productGetAllRequest.setParams(getProductData)
      await productGetAllRequest.fetch(function (content){
        _this.productCourses = content.products;
        _this.overlay = false;
      } , function (content){
        _this.overlay = false;
      });
    },
    async makeBase64Pic(e){
      const _this = this;
      let file = e.target.files[0]
      _this.base64ImageSrc = URL.createObjectURL(file)
      _this.defaultData.imageFile = await _this.readAsDataURL(file);
    },
    async makeBase64(e){
      const _this = this;
      let file = e.target.files[0]
      _this.defaultData.trailerFile = await _this.readAsDataURL(file);
    },
    deleteProductPic(){
      this.defaultData.imageFile = '';
      this.base64ImageSrc = null
    },
    customButtonClick() {
      this.showHTML = !this.showHTML

      const editor = document.querySelector('.ql-editor')
      if (editor.classList.contains('d-none')) {
        this.product.description = this.rawHTML
        editor.classList.remove('d-none')

      } else {
        this.rawHTML = this.product.description
        editor.classList.add('d-none')
      }
    },
    setEditorContent(content){
      this.defaultData.description = content
    },
  },
}
</script>

<style scoped>

</style>